import { Record } from "immutable";

import { AccessReviewPermissionModel, type TAccessReviewPermissionStatus } from "./AccessReviewPermissionModel";
import { AccessReviewResourceModel } from "./AccessReviewResourceModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";

const defaults = {
  accessReviewPermission: null as AccessReviewPermissionModel | null,
  accessReviewPermissionId: "",
  accessReviewResource: null as AccessReviewResourceModel | null,
  accessReviewResourceId: "",
  createdAt: new Date(0),
  id: "",
  status: "" as TAccessReviewPermissionStatus,
  virtualRole: null as IntegrationResourceRoleModel | null,
  virtualRoleId: "",
};

export class AccessReviewResourcePermissionModel extends Record<typeof defaults>(defaults) {
  get integrationId() {
    return this.virtualRole
      ? this.virtualRole.integrationResource!.integrationId
      : this.accessReviewPermission!.integrationActorPermission!.integrationActor!.integrationId;
  }

  get resourceName() {
    return this.virtualRole ? this.virtualRole.integrationResource!.name : this.accessReviewPermission!.resourceName;
  }

  get roleName() {
    return this.virtualRole ? this.virtualRole.name : this.accessReviewPermission!.roleName;
  }

  static fromServerData(data: unknown): AccessReviewResourcePermissionModel {
    const {
      accessReviewPermission,
      accessReviewPermissionId,
      accessReviewResource,
      accessReviewResourceId,
      createdAt,
      id,
      status,
      virtualRole,
      virtualRoleId,
    } = data as typeof defaults;
    return new AccessReviewResourcePermissionModel({
      accessReviewPermission: accessReviewPermission
        ? AccessReviewPermissionModel.fromServerData(accessReviewPermission)
        : null,
      accessReviewPermissionId,
      accessReviewResource: accessReviewResource
        ? AccessReviewResourceModel.fromServerData(accessReviewResource)
        : null,
      accessReviewResourceId,
      createdAt: new Date(createdAt),
      id,
      status,
      virtualRole: virtualRole ? IntegrationResourceRoleModel.fromServerData(virtualRole) : null,
      virtualRoleId,
    });
  }
}
